<template>
  <div id="app">
    <van-nav-bar title="王者荣耀点券充值" />
    <van-form @submit="onSubmit" style="margin-top:20px" >
      <van-cell-group inset>
        <van-nav-bar title="订单确认" style="margin-top:6px" />
        <van-field name="radio" label="角色系统">
          <template #input>
            <van-radio-group v-model="checked" direction="horizontal">
              <van-radio name="2">ios</van-radio>
              <van-radio name="1">android</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-model="userqq"
          name="账号"
          label="账号"
          placeholder="请填写用户QQ"
          :rules="[{ required: true, message: '请填写用户QQ' }]"
        />
        <van-field name="stepper" label="游戏区服-手Q">
          <template #input>
            <van-stepper integer v-model="userArea" :min="min" :max="max"/>
          </template>
        </van-field>
        <van-field
          v-model="detail"
          name="区服详细信息"
          label="区服详细信息"
          :rules="[{ required: true, message: '未获取到区服信息' }]"
          disabled
        />
        <van-field name="stepper" label="点券充值数量">
          <template #input>
            <van-stepper v-model="num"  :min="1"/>
          </template>
        </van-field>
      </van-cell-group>
      <div style="margin: 16px;">
        <van-button round block  color="rgba(25,137,250)" native-type="submit">
          生成订单
        </van-button>
      </div>
    </van-form>
    <van-dialog
      v-model="showDialog"
      show-cancel-button
      title="生成成功"
      class="copyStr"
      @confirm="onConfirm"
      @cancel="onCancel"
      :data-clipboard-text="url"
      confirm-button-text="点击跳转"
      cancel-button-text="点击复制"
    >
   <div id="qrImg" style="width:260px;height:260px;margin:0 auto;display: flex; justify-content: center;">
    <canvas ref="codeImg" style="width:100%;height:100%"/>
  </div>
    </van-dialog>
  </div>
</template>

<script>
import { configIos,configA } from './const'
import Clipboard from 'clipboard';
import QrCode from 'qrcode'
export default {
  name: 'App',
  data() {
    return {
      showDialog: false,
      userqq: '',
      checked: '2',
      userArea: 1,
      num: 1,
      min:1,
      detail: '',
      max: 120,
      url:'',
    }
  },
  mounted() {
  },
  watch: {
    checked: {
      handler (nV) {
        this.fnChange()
      },
      immediate: true,
    },
    userArea: {
      handler (nV) {
        this.fnChange()
      },
      immediate: true,
    },
  },
  methods: {
    onConfirm(){
      window.location.href = this.url
    },
    onCancel (){
      const clipboard = new Clipboard('.copyStr');
      clipboard.on('success', e => {
        alert('复制成功')
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        // 不支持复制
        alert("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy()
      })
    },
    fnChange(e){
      if(!this.userArea && this.userArea !== 0) {return}
      if(this.checked === '2') {
        this.min = 1
        this.max = configIos.length
        this.detail = configIos.filter(item => item.id == this.userArea)[0].value
      } else if (this.checked === '1'){
        this.min = 0
        this.max = 450
        this.detail = configA.filter(item => item.id == this.userArea)[0].value
      }
    },
    onSubmit(){
      if(this.checked === '1'){
        alert('安卓让用户自己发起代付吧')
      } else{
        this.url = 'https://pay.qq.com/h5/index.shtml?m=buy&c=game&pf=mds_private-__mds_private_aW9zd2hpdGVsaXN0_t25.default-iap&appid=1450002260&zoneid='+Math.round(2010+this.userArea)+ '&n='+this.num+'&as=1&u='+this.userqq+'&author=Askook'
        this.showDialog = true
        this.$nextTick(()=>{
          QrCode.toCanvas(this.$refs.codeImg, this.url)
        })
      }
    },
  }
}
</script>

<style>
html,body{
  height: 100%;
}
#app {
  width: 100%;
  background: #f6f6f6;
  height: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  color: #2c3e50;
}
</style>
